import { useSyncExternalStore } from 'react';

import type { AgentFeedItem } from '../types';
import { getSnapshot, subscribe } from './agentFeedStore';

/** Subscribe to the agent feed store and return the current in-progress items. */
export function useAgentFeedItems(): ReadonlyArray<AgentFeedItem> {
  return useSyncExternalStore(subscribe, getSnapshot);
}
